import { GetServerSideProps } from 'next'
import React from 'react'

import { CMSPage } from '@Components/CMS/Page'
import { ReturnLogin } from '@Domains/Returns/Features/Login/ReturnLogin'
import { Page, PageType } from '@Generated/graphql'
import { initializeApolloFromContext } from '@Globals/Apollo'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'
import { PageHOC } from '@Globals/Page/Client'
import { boostFromContext, handleRedirect, pageProps } from '@Globals/Page/Server'
import { PageProps } from '@Globals/Page/Types'
import { getSinglePost } from '@Queries/cms/SinglePost.query'

import styles from './returns.module.scss'

interface OrderReturnProps extends PageProps {
  item: Page
}
export const getServerSideProps: GetServerSideProps<OrderReturnProps> = async (context) => {
  const apolloClient = initializeApolloFromContext(context)
  const post = await getSinglePost(
    apolloClient,
    PageType.Returns,
    '/returns',
    undefined,
    boostFromContext(context),
    context?.req?.thSplitTests,
  )
  const { page } = post.data

  if (!page) {
    return {
      notFound: true,
    }
  }

  if (page?.type === 'redirect_permanent' || page?.type === 'redirect_temporary') {
    return handleRedirect(context, page.url, page.type)
  }
  return {
    props: {
      ...await pageProps(
        context,
        { type: 'other', id: '' },
        page,
        ['cart', 'cms', 'common', 'footer', 'giftcard', 'header', 'products', 'shipping', 'sidebar', 'validation', 'review', 'return'],
      ),
      initialApolloState: apolloClient.cache.extract(),
      item: page as Page,
    },
  }
}

const OrderReturnPage = PageHOC<OrderReturnProps>(({ item }) => {
  const components = useBlockComponents(item.blocks || [])
  return (
    <CMSPage>
      <ReturnLogin className={styles.returnsWrapper} />
      {components}
    </CMSPage>
  )
})

export default OrderReturnPage
